<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <vue-element-loading
          :active="appLoading"
          :is-full-screen="true"
          background-color="#FFFFFF"
          color="blue"
          spinner="mini-spinner"
        />
        <ServerError v-if="ServerError" />
        <v-layout wrap>
          <v-flex xs12 pa-2>
            <span> <h2>Whale Shark Conservation Project</h2></span>
          </v-flex>
          
          <!-- User Count Card - Redesigned -->
          <v-flex xs12 sm6 pa-2>
            <v-card 
              elevation="8" 
              to="/userlist"
              class="stat-card user-card"
              :ripple="true"
            >
              <v-layout wrap>
                <v-flex xs12>
                  <div class="card-header">
                    <div class="icon-container">
                      <v-icon size="40" color="white">mdi-account-group</v-icon>
                    </div>
                    <div class="card-title">
                      <h3>Total Users</h3>
                      <p>Registered community members</p>
                    </div>
                  </div>
                  <div class="card-content">
                    <div class="stat-number">{{ usercount }}</div>
                    <div class="stat-label">Active Users</div>
                  </div>
                  <div class="card-footer">
                    <v-btn 
                      text 
                      color="white" 
                      class="view-btn"
                      small
                    >
                      View Details
                      <v-icon right small>mdi-arrow-right</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <!-- Record Count Card - Redesigned -->
          <v-flex xs12 sm6 pa-2>
            <v-card 
              elevation="8" 
              to="/reports"
              class="stat-card record-card"
              :ripple="true"
            >
              <v-layout wrap>
                <v-flex xs12>
                  <div class="card-header">
                    <div class="icon-container">
                      <v-icon size="40" color="white">mdi-fish</v-icon>
                    </div>
                    <div class="card-title">
                      <h3>Total Records</h3>
                      <p>Whale shark sightings</p>
                    </div>
                  </div>
                  <div class="card-content">
                    <div class="stat-number">{{ recordcount }}</div>
                    <div class="stat-label">Sightings Recorded</div>
                  </div>
                  <div class="card-footer">
                    <v-btn 
                      text 
                      color="white" 
                      class="view-btn"
                      small
                    >
                      View Reports
                      <v-icon right small>mdi-arrow-right</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

        </v-layout>
        <v-layout wrap>
          <v-flex xs12 class="sbold"
            ><span><h2>Recent Reports</h2></span></v-flex
          >
          <v-flex xs12 v-if="details" class="sbold">
            <div class="table-card">
            <v-simple-table class="dashboard-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left;" style="font-size: 15px">No.</th>
                    <th class="text-left;" style="font-size: 15px">Username</th>
                    <th class="text-left" style="font-size: 15px">Date</th>
                    <th class="text-left" style="font-size: 15px">Boat Name</th>
                    <th class="text-left" style="font-size: 15px">Boat No.</th>
                    <th class="text-left" style="font-size: 15px">Spot</th>
                    <th class="text-left" style="font-size: 15px">
                      Expected Length(ft)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, i) in details" :key="i">
                    <!-- <td>{{ i + 1 }}</td> -->
                    <td>
                      <span>
                        {{ i + 1 }}
                      </span>
                    </td>
                    <td v-if="value.userid">
                      <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                        {{ value.userid.first_name
                        }}{{ value.userid.last_name }}
                        </router-link>
                    </td>
                    <td v-if="value.create_date">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ formatDate(value.create_date) }}
                       </router-link>
                    </td>

                    <td v-if="value.boatname">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ value.boatname }}
                       </router-link></td>
                    <td v-if="value.boatno">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ value.boatno }}
                       </router-link></td>
                    <td v-if="value.field">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ value.field }}
                       </router-link></td>
                    <td v-if="value.length">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ value.length }}
                       </router-link></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap pt-2>
          <v-flex xs12>
            <div class="map-card">
              <div id="googlemap2"></div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyB-wSOSvoBXfA5vn-23GR7OU5qTm8BFwlk&libraries=visualization,drawing">
</script>
<script>
import axios from "axios";
import store from "../../store";
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      userList: [],
      details: [],
      recordcount: 0,
      usercount: 0,
      gmap2: null,
      latt: null,
      lonn: null,
      icons: "",
      locations: null,
    };
  },

  computed: {
    userName() {
      return store.state.USDD;
    },
  },

  mounted() {
    this.getData();
    this.getMap();
  },

  methods: {
    addd() {
      store.commit("USD", "this is the second valur");
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/home",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.recordcount = response.data.recordcount;
            this.usercount = response.data.usercount;
            this.details = response.data.data;

            this.locations = response.data.locations;
            for (let i = 0; i < this.locations.length; i++) {
              this.latt = this.locations[i].location[1];
              this.lonn = this.locations[i].location[0];
              this.marker = new google.maps.Marker({
                position: { lat: this.latt, lng: this.lonn },
                map: this.gmap2,
                icon: this.icons,
              });
              const infowindow = new google.maps.InfoWindow({
                content: String(
                  "<h3>" +
                    this.locations[i].boatname +
                    "</h3>" +
                    '<a href="/uploaddetail?id=' +
                    this.locations[i]._id +
                    '"><button class="RB " style="color:#d39c00;font-size:12px" >View Details</button></a>'
                ),
                maxWidth: 500,
              });
              this.marker.addListener("click", (eve) => {
                infowindow.open(this.map3, this.marker);
                infowindow.setPosition(eve.latLng);
              });
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " , " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;

      return strTime;
    },
    getMap() {
      this.gmap2 = new google.maps.Map(document.getElementById("googlemap2"), {
        center: { lat: 9.5260093, lng: 76.8144186 },
        zoom: 2,
      });
    },
  },
};
</script>
<style scoped>
#googlemap2 {
  height: 420px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
table.v-table thead th {
  font-size: 20px !important;
}

/* Table card wrapper */
.table-card {
  background: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  overflow: hidden;
}

/* Table styles */
.dashboard-table {
  font-size: 14px;
}

.dashboard-table thead th {
  background: #f7fafc;
  color: #2d3436;
  font-weight: 600;
  height: 56px;
}

.dashboard-table tbody tr {
  transition: background 0.2s ease;
}

.dashboard-table tbody tr:nth-child(even) {
  background: #fcfdff;
}

.dashboard-table tbody tr:hover {
  background: #f5f9ff;
}

.dashboard-table td, .dashboard-table th {
  padding: 14px 16px !important;
}

.dashboard-table td:first-child, .dashboard-table th:first-child {
  width: 64px;
  color: #4a5568;
}

/* Modern Stat Cards Styling */
.stat-card {
  border-radius: 16px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 200px;
  position: relative;
  background: #ffffff;
  border: 1px solid #edf2f7;
}

.stat-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
}

/* User Card Styling */
.user-card {
  background: #ffffff;
  color: #2d3436;
}

/* Record Card Styling */
.record-card {
  background: #ffffff;
  color: #2d3436;
}

/* Card Header */
.card-header {
  display: flex;
  align-items: center;
  padding: 20px 24px 16px;
  position: relative;
  z-index: 2;
}

.icon-container {
  background: rgba(45, 52, 54, 0.06);
  border-radius: 12px;
  padding: 12px;
  margin-right: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(45, 52, 54, 0.08);
}

/* Per-card accent colors */
.user-card .icon-container { background: rgba(92, 107, 192, 0.12); border-color: rgba(92, 107, 192, 0.18); }
.user-card .icon-container .v-icon { color: #5c6bc0 !important; }
.record-card .icon-container { background: rgba(236, 64, 122, 0.12); border-color: rgba(236, 64, 122, 0.18); }
.record-card .icon-container .v-icon { color: #ec407a !important; }

.card-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #2d3436;
}

.card-title p {
  margin: 4px 0 0 0;
  font-size: 12px;
  opacity: 0.7;
  font-weight: 400;
  color: #2d3436;
}

/* Card Content */
.card-content {
  padding: 0 24px 16px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: #2d3436;
}

.stat-label {
  font-size: 14px;
  font-weight: 500;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #2d3436;
}

/* Card Footer */
.card-footer {
  padding: 0 24px 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 2;
}

.view-btn {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  border-radius: 8px;
  padding: 8px 16px;
}

.view-btn:hover {
  background: rgba(45, 52, 54, 0.06);
  transform: translateX(4px);
}

/* Per-card button accent */
.user-card .view-btn { color: #5c6bc0 !important; }
.user-card .view-btn:hover { background: rgba(92, 107, 192, 0.08) !important; }
.record-card .view-btn { color: #ec407a !important; }
.record-card .view-btn:hover { background: rgba(236, 64, 122, 0.08) !important; }

/* Responsive Design */
@media (max-width: 600px) {
  .stat-card {
    min-height: 180px;
  }
  
  .card-header {
    padding: 16px 20px 12px;
  }
  
  .icon-container {
    padding: 10px;
    margin-right: 12px;
  }
  
  .icon-container .v-icon {
    font-size: 32px !important;
  }
  
  .card-title h3 {
    font-size: 16px;
  }
  
  .card-title p {
    font-size: 11px;
  }
  
  .card-content {
    padding: 0 20px 12px;
  }
  
  .stat-number {
    font-size: 36px;
  }
  
  .stat-label {
    font-size: 12px;
  }
  
  .card-footer {
    padding: 0 20px 16px;
  }
}

/* Animation for numbers */
.stat-number {
  animation: countUp 1s ease-out;
}

@keyframes countUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hover effects for interactive elements */
.stat-card .v-btn {
  transition: all 0.3s ease;
}

.stat-card .v-btn:hover {
  background: rgba(45, 52, 54, 0.12) !important;
}

/* Glass morphism effect */
.stat-card {
  backdrop-filter: blur(8px);
}

/* Map card styling */
.map-card {
  background: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(0,0,0,0.06);
}

.map-card #googlemap2 {
  height: 420px;
}
</style>